import PropTypes from "prop-types";

export const callToActionPropType = PropTypes.shape({
  linkType: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
});
